import styled from 'styled-components';
import {dFlexColumn, dFlexCenter} from '../../../globalVariables/GlobalFlex';

export const content = styled.div`
    ${dFlexColumn}
    height: 100%;
`;

export const empty = styled.div`
    ${dFlexCenter}
    height: 100%;
    padding: var(--space-xl);
    text-align: center;
    font-size: var(--font-size-body);
    color: var(--color-text-subtle);
`;
